// export const COLOR_PRIMARY_1 = '#0183D5';
// export const COLOR_SECONDARY_1 = '#0BCF97';

// export const COLOR_GREY_TINT = '#0183D5';
// export const COLOR_GREEN_TINT = '#10b17e';
// export const COLOR_GREY_LIGHT = 'rgba(44,48,56,0.8)';
// export const COLOR_GMBH = 'linear-gradient(to bottom, black 0%, black 33%, red 33%, red 66%, orange 66%, orange 100%) !important';
// export const COLOR_RED_TINT = 'rgba(147,60,76,1)';
// export const COLOR_BG_LIGHT = '#F5F6FA';

// export const COLOR_TABLE_HEADER = '#EFF2F7';
// export const COLOR_HEADER = '#DEE2E6';

// export const BORDER_GREY_LIGHT = '#ddd';

export const COLOR_PRIMARY_1 = '#0183D5';
export const COLOR_SECONDARY_1 = '#0acf97';

export const COLOR_GREY_TINT = '#0183D5';
export const COLOR_GREEN_TINT = '#10b17e';
export const COLOR_GREY_LIGHT = 'rgba(44,48,56,0.8)';
export const COLOR_GMBH = 'linear-gradient(to bottom, black 0%, black 33%, red 33%, red 66%, orange 66%, orange 100%) !important';
export const COLOR_RED_TINT = 'rgba(147,60,76,1)';
export const COLOR_BG_LIGHT = '#F5F6FA';

export const COLOR_TABLE_HEADER = '#EFF2F7';
export const COLOR_HEADER = '#DEE2E6';

export const BORDER_GREY_LIGHT = '#ddd';
